import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialogContent: {
    gap: theme.spacing.space24,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,

    [BreakPointTablet]: {
      gap: theme.spacing.space12,
    },
    [BreakPointMobile]: {
      gap: theme.spacing.space12,
    },
  },

  header: {
    [BreakPointTablet]: {
      fontSize: `20px !important`,
    },
    [BreakPointMobile]: {
      fontSize: `20px !important`,
    },
  },

  contentText: {
    [BreakPointTablet]: {
      fontSize: `12px !important`,
    },
    [BreakPointMobile]: {
      fontSize: `12px !important`,
    },
  },
}));
